import { Tenant } from 'shared/types';

import { api } from './axiosInstance';

export const fetchTenantByOldAvailabilityToken = async (token: string) => api.get<Tenant>(`/Tenants/GetTenantInfoByToken/${ token }`);

export const fetchTenant = async () => {
    return await api.get<Tenant>('/Tenants/GetTenantExternalInfo');
};

